export type OverrideStatus = 'force_sold_out' | 'force_available' | 'none';

export interface InventoryOverride {
  id: string;
  product_handle: string;
  override_status: OverrideStatus;
  reason: string | null;
  created_at: string;
  updated_at: string;
}

/**
 * Resolve whether a product should be treated as sold out.
 * Order of precedence:
 * 1. force_sold_out  -> true (unavailable regardless of Shopify)
 * 2. force_available -> false (available regardless of Shopify)
 * 3. none            -> fall back to Shopify availability
 */
export const isForceSoldOut = (override?: InventoryOverride): boolean => {
  if (!override) return false;
  return override.override_status === 'force_sold_out';
};

export const isForceAvailable = (override?: InventoryOverride): boolean => {
  if (!override) return false;
  return override.override_status === 'force_available';
};

export const getEffectiveAvailability = (
  override: InventoryOverride | undefined,
  shopifyAvailable: boolean
): boolean => {
  if (override?.override_status === 'force_sold_out') return false;
  if (override?.override_status === 'force_available') return true;
  return shopifyAvailable;
};

export const statusLabel = (status: OverrideStatus): string => {
  switch (status) {
    case 'force_sold_out':
      return 'Force Sold Out';
    case 'force_available':
      return 'Force Available';
    case 'none':
    default:
      return 'Use Shopify';
  }
};
